'use client';

import { useLocaleStore } from '@/client/stores/useLocaleStore';
import { LocaleButton } from '@/components/ui/locale-button';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';

interface Props {
  className?: ClassValue;
}

export function ToggleLocaleButton({ className }: Props) {
  const { locale, setLocale } = useLocaleStore();
  return <LocaleButton className={cn('font-sans', className)} locale={locale} onClick={() => setLocale(locale === 'kr' ? 'en' : 'kr')} />;
}
